import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { getListPeriode } from "@/services/getData"
import { Periode } from "@/types"
import { ChevronRight } from "lucide-react"
import React, { useState } from "react"
import { LuListFilter } from "react-icons/lu"
import { useQuery } from "@tanstack/react-query"
import { useNavigate, useSearchParams } from "react-router-dom"

export default function FormFilter({ closeModal }: { closeModal: () => void }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const idsPeriode = searchParams.get("ids_sys_periode")

  const [selectedFilter, setSelectedFilter] = useState("PERIODE")
  const [filter, setFilter] = useState<{
    periode: string[]
  }>({
    periode: idsPeriode?.split("-") || [],
  })

  const { data: dataPeriode, isPending: isPendingDataPeriode } = useQuery({
    queryKey: ["listPeriode"],
    queryFn: () => getListPeriode(),
  })
  const listPeriodePasca = dataPeriode
    ? dataPeriode?.filter((periode: Periode) => {
        return periode.jalur_jenis?.nama_jalur_jenis_slug === "pascasarjana"
      })
    : []

  const handleApplyFilter = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (filter.periode.length > 0) {
      searchParams.set("ids_sys_periode", filter.periode.join("-"))
    } else {
      searchParams.delete("ids_sys_periode")
    }

    navigate(`/verifikator-pasca/data-nilai?${searchParams.toString()}`)
    closeModal()
  }

  return (
    <form
      onSubmit={handleApplyFilter}
      className="pb-20 relative flex flex-col gap-y-3"
    >
      <FormHeader title="Filter Data Rekap" icon={<LuListFilter />} />

      <section className="p-3 relative border rounded-xl max-h-[50vh] overflow-auto">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "PERIODE" ? "" : "PERIODE"))
          }
        >
          <span className="font-bold">Periode</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "PERIODE" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "PERIODE" &&
          (isPendingDataPeriode ? (
            "Loading..."
          ) : (
            <>
              <div className="mt-3 grid grid-cols-1 gap-5">
                {listPeriodePasca?.map((periode: Periode) => {
                  const isChecked = (filter.periode as string[]).includes(
                    String(periode.id_sys_periode)
                  )

                  return (
                    <div key={periode.id_sys_periode} className="flex gap-3">
                      <Checkbox
                        checked={isChecked}
                        onCheckedChange={(checked) => {
                          setFilter((prev) => ({
                            ...prev,
                            periode: checked
                              ? [String(periode.id_sys_periode)] // replace dengan satu saja
                              : [], // kosongkan
                          }))
                        }}
                      />
                      <Label>
                        {periode.jalur_jenis?.nama_jalur_jenis} Gelombang-
                        {periode.gelombang}
                      </Label>
                    </div>
                  )
                })}
              </div>
            </>
          ))}
      </section>

      <div className="absolute bottom-3 left-3 right-3">
        <div className="flex justify-between">
          <div className="flex gap-3">
            <Button
              onClick={() => closeModal()}
              type="button"
              variant={"outline"}
            >
              Tutup
            </Button>
            <Button>Terapkan Filter</Button>
          </div>
          <Button
            type="button"
            variant={"outline"}
            onClick={() => {
              setFilter((prev) => ({
                ...prev,
                periode: [],
              }))
              navigate("/verifikator-pasca/data-nilai")
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    </form>
  )
}
